module.exports = __webpack_public_path__ + "static/img/voice1_down.75e1f81e.png";